import { Component, h, Prop, Element } from "@stencil/core";
import { AccommodationType } from "../nj-connection/AccommodationType";
import { i18n } from '../../utils/I18n';
import { getCompartmentTitle } from "../nj-connection/AccommodationUtils";


@Component({
    tag: "nj-best-price",
    styleUrl: "nj-best-price.scss",
    shadow: true
})

export class NjBestPrice {
    @Element() el: HTMLElement;

    @Prop() public accommodation: AccommodationType;
    @Prop() public elTitle?: string;
    @Prop() public isPrivate: boolean = false;
    @Prop() public selected: boolean = false;
    @Prop() public price: string;
    @Prop() public text?: string;

    getIcon() {
        switch (this.accommodation) {
            case AccommodationType.Se:
                return <seat-icon />;
            case AccommodationType.Le:
                return <couchette-icon />;
            case AccommodationType.Be:
                return <sleeper-icon />;
        }
    }

    getTitle() {
        return this.isPrivate ? this.elTitle : getCompartmentTitle(this.accommodation) ?? "";
    }

    getText() {
        return this.isPrivate ? this.text : i18n.getMessage("reservation.offer-list.price.starting-from", "", [this.price]);
    }

    render() {
        const title = this.getTitle();
        return (
            <div class={{
                "best-price": true,
                "best-price--selected": this.selected
            }} > {this.selected && <check-icon/>}
                {this.getIcon()}{' '}
                {title && (<span class="screen-reader-text">{title}</span>)}
                {this.getText()}{' '}
            </div>
        );
    }
}
